import { useMutation, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  cambiarEstadoClaveSatCentroCosto,
  crearClaveSatCentroCosto,
  eliminarMasivoClavesSatCentrosCosto,
  establecerClaveSatCentroCostoAutomatico,
  type CrearClaveSatCentroCostoInput,
} from "../services/clave-sat-centro-costo-service";

function invalidar(qc: ReturnType<typeof useQueryClient>) {
  void qc.invalidateQueries({ queryKey: qk.adminClavesSatCentrosCosto });
}

export function useCrearClaveSatCentroCosto(opts?: { onCreado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CrearClaveSatCentroCostoInput) => crearClaveSatCentroCosto(input),
    onSuccess: () => {
      toastExito({ title: "Relación creada", message: "La clave SAT ya puede derivar este centro de costo en el prorrateo automático." });
      invalidar(qc);
      opts?.onCreado?.();
    },
    onError: toastErrorApi,
  });
}

export function useEstablecerClaveSatCentroCostoAutomatico() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id }: { id: string; claveSat: string; centroCodigo: string }) =>
      establecerClaveSatCentroCostoAutomatico(id),
    onSuccess: (_data, vars) => {
      toastExito({
        title: "Centro de costo automático actualizado",
        message: `La clave ${vars.claveSat} usará el centro de costo ${vars.centroCodigo} en el prorrateo automático.`,
      });
      invalidar(qc);
    },
    onError: toastErrorApi,
  });
}

export function useCambiarEstadoClaveSatCentroCosto() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, activo }: { id: string; claveSat: string; activo: boolean }) =>
      cambiarEstadoClaveSatCentroCosto(id, activo),
    onSuccess: (_data, vars) => {
      toastExito({
        title: vars.activo ? `"${vars.claveSat}" reactivado` : `"${vars.claveSat}" dado de baja`,
        message: vars.activo
          ? "Vuelve a ser candidato del prorrateo automático."
          : "Deja de ser candidato · si era el automático, la bandera pasa al siguiente por código.",
      });
      invalidar(qc);
    },
    onError: toastErrorApi,
  });
}

export function useEliminarMasivoClavesSatCentrosCosto(opts?: { onEliminado?: () => void }) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => eliminarMasivoClavesSatCentrosCosto(ids),
    onSuccess: (res) => {
      toastExito({ title: "Relaciones eliminadas", message: `${res.eliminadas} eliminadas.` });
      invalidar(qc);
      opts?.onEliminado?.();
    },
    onError: toastErrorApi,
  });
}
